import styled from '@emotion/styled';

const LogEntryCoachCommentsDivider = styled('hr')(({ theme }) => ({
  margin: 0,
  marginTop: 16,
  marginLeft: -24,
  width: 'calc(100% + 48px)',
  border: 'none',
  borderBottom: `2px solid ${theme.palette.divider}`,
}));

export default LogEntryCoachCommentsDivider;
